export const gzpUrls = [
  "www.gamezop.com",
  "www.gamezop.co",
  "www.gamezop.in",
  "www.gamezop.net",
  "www.gamezoppro.com",
  "www.gzp.gg",
  "www.gamezop.io",
  "www.gamezop.id",
  "www.gamezop.mobi",
  "www.gamezopapk.com",
  "www.gamezop.us",
]

export const ROUTES = [
  { path: "/terms-of-use", text: "Terms of Use" },
  { path: "/privacy", text: "Privacy and Cookie Policy" },
]
